<template>
  <footer class="footer section-padding bg-dark-blue">
    <div class="container">
      <div class="row">
        <div class="col-6 col-sm-4 col-lg-3">
          <div class="footer-widget mb-4 mb-sm-0">
            <h5 class="fw-semi-bold text-dark-400 widget-title text-white mb-3">
              Company
            </h5>
            <ul class="list-unstyled widget-item">
              <li>
                <router-link to="/about" class="text-gray mb-2">About</router-link>
              </li>
              <li>
                <router-link to="/career" class="text-gray mb-2">Career</router-link>
              </li>
              <li>
                <router-link to="/price" class="text-gray mb-2">Markets</router-link>
              </li>
              <li>
                <router-link to="/wallet" class="text-gray mb-2">Wallet</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-lg-3">
          <div class="footer-widget mb-4 mb-sm-0">
            <h5 class="fw-semi-bold text-dark-400 widget-title text-white mb-3">
              Support
            </h5>
            <ul class="list-unstyled widget-item">
              <li>
                <router-link to="/contact" class="text-gray mb-2">Contact</router-link>
              </li>
              <li>
                <router-link to="/faq" class="text-gray mb-2">FAQ</router-link>
              </li>
              <li>
                <router-link to="/blog" class="text-gray mb-2">Blog</router-link>
              </li>
              <li>
                <router-link to="/helpdesk" class="text-gray mb-2">Helpdesk</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-lg-6">
          <div class="footer-widget">
            <h5 class="fw-semi-bold text-dark-400 widget-title text-white mb-3">
              Exchange Pair
            </h5>
            <div class="row">
              <div class="d-flex justify-content-sm-between">
                <ul class="list-unstyled widget-item">
                  <li>
                    <router-link to="/price" class="text-gray mb-2">ETH to BTC</router-link>
                  </li>
                  <li>
                    <router-link to="/price" class="text-gray mb-2">BTC to ETH</router-link>
                  </li>
                  <li>
                    <router-link to="/price" class="text-gray mb-2">LTC to ETH</router-link>
                  </li>
                  <li>
                    <router-link to="/price" class="text-gray mb-2">USDT to BTC</router-link>
                  </li>
                </ul>
                <ul class="list-unstyled widget-item ms-5 ms-sm-0">
                  <li>
                    <router-link to="/price" class="text-gray mb-2">BTC to USDT</router-link>
                  </li>
                  <li>
                    <router-link to="/price" class="text-gray mb-2">LTC to BTC</router-link>
                  </li>
                  <li>
                    <router-link to="/price" class="text-gray mb-2">XMR to BTC</router-link>
                  </li>
                  <li>
                    <router-link to="/price" class="text-gray mb-2">ETC to DASH</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "LandingFooter",
};
</script>
